import { Box, CircularProgress, Typography } from "@mui/material";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";

export const CALCULATE_PROMPT = "Click Calculate to display the report";
export const CALCULATING_MESSAGE = "Calculating report…";

/**
 * What stands in for the report below the action row until a run for the
 * inputs on screen has landed (task 5001): the figures, charts and cards are
 * hidden rather than shown as placeholders a reader could mistake for the
 * client's numbers. While that run is in flight it says so instead.
 */
const CalculatePrompt = ({ isCalculating }: { isCalculating: boolean }) => (
  <Box
    role="status"
    sx={{
      mt: 3,
      py: { xs: 6, md: 10 },
      px: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2,
      textAlign: "center",
      border: "2px dashed",
      borderColor: "primary.light",
      borderRadius: 2,
      backgroundColor: "#F7FCFF",
      color: "#1B4F72",
    }}
  >
    {isCalculating ? (
      <CircularProgress aria-hidden size={48} />
    ) : (
      <CalculateOutlinedIcon aria-hidden sx={{ fontSize: 56 }} />
    )}
    <Typography variant="h5" component="p" sx={{ fontWeight: "bold" }}>
      {isCalculating ? CALCULATING_MESSAGE : CALCULATE_PROMPT}
    </Typography>
  </Box>
);

export default CalculatePrompt;
